import DefaultLayout from "@/layouts/DefaultLayout";
import { NextPage } from "next";
import { NextSeo } from "next-seo";
import ArchitectureSearchGroup from "@/components/ArchitectureSearchGroup";
import { ArchitectureResultTabType } from "@/consts/tabType";
import PostItemList from "@/features/post/components/PostItemList";
import InfiniteScroll from "react-infinite-scroll-component";
import Circular from "@/components/Circular";
import NotFoundSearchView from "@/components/NotFoundSearchView";
import PostItem from "@/features/post/components/PostItem";
import usePostSearch from "@/features/post/hooks/usePostSearch";
import usePageViewOnSearch from "@/hooks/usePageViewOnSearch";

const ArchitecturesSearchPostsPage: NextPage = () => {
  usePageViewOnSearch();

  const {
    buildingTypeId,
    pagination: {
      data,
      dataLength,
      next,
      hasNext,
      notFound,
      totalCount,
      updateItem,
    },
    parameter: { query, queryController },
  } = usePostSearch();

  return (
    <DefaultLayout hiddenFooter={true}>
      <NextSeo
        title={`建築写真の検索結果`}
        description={`TECTURE内の建築写真を検索した結果`}
        noindex={true}
      />
      <ArchitectureSearchGroup
        tabType={ArchitectureResultTabType.Post}
        amount={totalCount}
        buildingTypeId={buildingTypeId}
        query={query}
        queryController={queryController}
      >
        <InfiniteScroll
          style={{ overflow: "visible" }}
          dataLength={dataLength}
          next={next}
          hasMore={hasNext}
          loader={<Circular />}
        >
          <PostItemList
            posts={data}
            onRender={(post) => (
              <PostItem
                key={post.id}
                post={post}
                mutate={(updatedPost) => updateItem(updatedPost, false)}
              />
            )}
          />
        </InfiniteScroll>

        {notFound && <NotFoundSearchView />}
      </ArchitectureSearchGroup>
    </DefaultLayout>
  );
};

export default ArchitecturesSearchPostsPage;
